<template #default>
    <div class="widget-container">
        <!-- <h2 class="content-block">New Order</h2> -->
        <div class="content-block dx-card responsive-paddings">
            <form action="action">
                <DxForm id="form1" :form-data="formData" label-mode="floating">
                    <DxGroupItem :col-count="2">
                        <DxSimpleItem data-field="PoDate" editor-type="dxDateBox" :editor-options="{ readOnly: true }">
                            <DxLabel :text="$t('orderAdd.poDate')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="PoNumber" :editor-options="{ readOnly: true }">
                            <DxLabel :text="$t('orderAdd.poNumber')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="Status" :editor-options="{ readOnly: true }">
                            <DxLabel :text="$t('orderAdd.status')" />
                        </DxSimpleItem> 
                    </DxGroupItem>

                    <DxGroupItem :col-count="1">
                        <DxSimpleItem name="OrderItemsGrid_">
                            <template #default>
                                <DxDataGrid id="OrderItemsGrid" :show-borders="true" :data-source="OrderItemsData"
                                    :row-alternation-enabled="true" :hover-state-enabled="true"
                                    :selection="{ mode: 'single' }" key-expr="Id">

                                    <DxColumn :caption="$t('orderAdd.items')" data-field="Items" width="400">
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.totalQuantity')" data-field="TotalQuantity"
                                        :allow-editing="false">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.rate')" data-field="Rate"
                                        :allow-editing="false">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.rate')" data-field="Currency"
                                        :allow-editing="false">
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.totalPrice')"
                                       format="#,##0.##"
                                       data-field="TotalPrice"
                                        :allow-editing="false">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxColumnFixing :enabled="true" />
                                    <DxGroupPanel :visible="true" />
                                </DxDataGrid>
                            </template>
                        </DxSimpleItem>
                    </DxGroupItem>

                    <DxGroupItem :col-count="3">
                        <DxSimpleItem data-field="TotalCharges" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.totalCharges')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="ShippingHandling" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.shippingHandling')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="TotalBeforeTaxes" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.totalBeforeTaxes')" />
                        </DxSimpleItem>
                    </DxGroupItem>

                    <DxGroupItem :col-count="2">
                        <DxSimpleItem :col-span="2" data-field="ShipToLocation"
                         :label="{ text: $t('orderAdd.shipToLocation') }" :editor-options="{ readOnly: true }" />

                        <DxSimpleItem :col-span="2" data-field="ShippingMethod" :editor-options="{ readOnly: true }"
                         :label="{ text: $t('orderAdd.shippingMethod') }"/>
                    </DxGroupItem>

                    <DxGroupItem :col-count="1">
                        <DxSimpleItem data-field="Notes" :editor-options="{ height: 90, readOnly: true }" editor-type="dxTextArea">
                            <DxLabel :text="$t('orderAdd.notes')" />
                        </DxSimpleItem>
                    </DxGroupItem>
                </DxForm>
            </form>
        </div>
    </div>
</template>

<script>
import DxForm, {
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    // DxItemPanel,
    // DxItem,    
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule,
} from 'devextreme-vue/form'

import DxCheckBox from 'devextreme-vue/check-box';
import DxTooltip from 'devextreme-vue/tooltip';


import DxItemPanel from "devextreme-vue/tab-panel"
import DxAutocomplete from 'devextreme-vue/autocomplete'
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxFormItem,
    DxLookup,
    DxMasterDetail,
    DxColumnFixing,
    DxGroupPanel,
} from 'devextreme-vue/data-grid'

import DxRadioGroup from 'devextreme-vue/radio-group'

import DxButton from 'devextreme-vue/button'

import notify from 'devextreme/ui/notify'
import dateUtil from '@/helpers/dateUtil'

import { mapState, mapActions } from 'vuex'

import {
    POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE
} from '@/store/_actiontypes'

export default {
    components: {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxButton,
        DxRadioGroup,
        DxLabel,
        DxItemPanel,
        DxItem,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxFormItem,
        DxLookup,
        DxMasterDetail,
        DxToolbar,
        DxRequiredRule,
        DxCompareRule,
        DxPatternRule,
        DxRangeRule,
        DxEmailRule,
        DxStringLengthRule,

        DxCheckBox,
        DxTooltip,

        DxForm,
        DxAutocomplete,
        DxAsyncRule,
        DxColumnFixing,
        DxGroupPanel,

        notify,
    },

    props: {
      templateData: {
        type: Object,
        default: () => {},
      },
    },

    data() {
        const incorporationData = {}
        const status = [
            {
                Id: 'Former',
                Name: 'Former'
            },
            {
                Id: 'Current',
                Name: 'Current'
            }
        ]

        return {
            CDP: {},
            ProductOptions: status,
            LastSelectedProduct: '',
            dataOperation: ['New', 'Update'],
            statusEditorOptions: status,
            AccountingPeriodData: [],
            AuditedAccountsData: [],
            CurrentCompanySecretariesData: [],
            DirectorsReportsData: [],
            AuditorsReportsData: [],
            OrderItemsData: [],
            AppointmentOfAuditorsData: [],
            ReasonOfTermination: [],
            accPeriod: '', extract: '', extractDate: '',
            dateOptions: { displayFormat: "dd-MM-yyyy" },
            selectedTabIndex: 0,
            isOrderVisible: true,
            formData: {},
            accountingPeriodOptions: {
                disabled: false,
                onValueChanged: e => {
                    //this.saveAccountingPeriodValue(e)
                },
            },
            extractOptions: {
                height: 70,
                onValueChanged: e => {
                    //this.saveExtractOfResolutionValue(e)
                },
            },
            incorporationData,
        }
    },

    computed: {
      ...mapState({
        payerId: state => state?.user?.user?.data?.payer?.id
      }),
      ShipToLocationOptions() {
        return [
          { Id: "Default", Name: this.$t('orderAdd.default') },
          { Id: "Dar es Salaam", Name: this.$t('orderAdd.darEsSalaam') }
        ]
      },
      ShippingMethodOptions() {
        return [
          { Id: 'standard', Name: this.$t('orderAdd.standardShipping') },
          { Id: 'expedited', Name: this.$t('orderAdd.expeditedShipping') }
        ]
      },
      buttonOptions() {
        return {
          text: this.$t('orderAdd.save'),
          type: 'normal',
          useSubmitBehavior: true
        }
      }
    },

    created() {
      console.log(this.templateData)
        this.loadRevenueSourceData()
        this.bindFormData()
    },

    methods: {
        ...mapActions("payment", [
            POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE
        ]),

        bindFormData() {
          this.formData = {
              ShipToLocation: this.templateData?.data?.Address,
              ShippingMethod: "Default",
              PoDate: this.templateData?.data?.PoDate,
              PoNumber: this.templateData?.data?.BatchNo,
              Status: this.templateData?.data?.Status,
              Notes: "N/A"
          }

          let data = this.templateData?.data?.Items
          this.OrderItemsData  = data.map((item, index) => {
            return {
                Id: index,
                No: index+1,
                Items: item.item_name,
                TotalQuantity: item.qty,
                Rate: item.rate,
                TotalPrice: Number(item.amount),
                Currency: item.ccy,
            }
        })

        // calculate total charges, total before taxes and shipping handling
        const total = this.OrderItemsData.reduce((sum, item) => sum + Number(item.TotalPrice), 0);
        this.formData.TotalCharges = Number(total);
        this.formData.ShippingHandling = Number(0);
        this.formData.TotalBeforeTaxes = Number(total);
            
        },

        handleShippingMethod(e) {

        },

        handleShipToLocation(e) {
            this.formData.Facility = e.value
            console.log(this.formData)
        },
        selectShippingMethod(method) {
            // this.formData.selectedShippingMethod = method;
        },

        loadRevenueSourceData() {
            this.GET_REVENUE_SOURCE().then(res => {
                this.ProductOptions = res.data?.body[0]?.sources.map((item, index) => {
                    return {
                        Id: item.id,
                        Name: item.source_name,
                        Rate: item.rate,
                        Currency: item.currency,
                        Min_qty: item.min_qty
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
        },

        resetInputFiels() {
            this.AuditedAccountsData = []
            this.DirectorsReportsData = []
            this.AuditorsReportsData = []
            this.OrderItemsData = []
            this.AppointmentOfAuditorsData = []
        },
    }
}
</script>
<style scoped>
.shipping-option {
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin-bottom: 10px;
    /* Space between options */
}

.shipping-option.selected {
    border-color: #007bff;
    /* Highlight selected option */
    background-color: #eaf5ff;
    /* Light blue background for selected */
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.dx-checkbox {
    margin-right: 8px;
    /* Space between checkbox and label */
}

.shipping-label {
    font-weight: bold;
}

.delivery-info {
    font-size: 0.9em;
    color: #666;
    margin-left: 28px;
    /* Align with the text above, considering checkbox width */
}

.info-icon-standard {
    margin-left: 5px;
    cursor: help;
    color: #888;
}
</style>